import { RangeStatic } from 'quill';

export const MENTION_MARKER = '@';

// NOTE: p{L} matches Unicode codepoints in the "letter" category, cf https://www.regular-expressions.info/unicode.html#prop
export const MENTION_EXP = new RegExp(MENTION_MARKER + '([\\w*\\d*\\p{L}\\-]*)', 'u');

export default class ChatMentionExpression {
  constructor(
    readonly content: string,
    readonly start: number,
    readonly length: number,
    readonly caret: number,
  ) {
  }

  static atSelection(range: RangeStatic, content: string): ChatMentionExpression | undefined {
    const end = range.index;
    const start = content.lastIndexOf(MENTION_MARKER, end - 1);
    if (start >= 0) {
      const candidate = content.substring(start);
      const match = candidate.match(MENTION_EXP);
      const expression = match && match[0];
      if (expression && start + expression.length >= end) {
        return new ChatMentionExpression(content, start, expression.length, end);
      }
    }
  }

  getValue(): string {
    return this.content.substring(this.start + MENTION_MARKER.length, this.caret);
  }
}